export default __webpack_public_path__ + "static/media/thinkbook_logo.feb64fdf.svg";